import graphql__503e376bc0c71fc8ee74 from "./__generated__/AuthenticationCaptcha_authenticationConfig.graphql.js";import { graphql, useFragment } from "react-relay";

import CaptchaField from "../Form/Field/CaptchaField";

const AuthenticationCaptcha = props => {
  const authenticationConfig = useFragment(
    AuthenticationCaptcha_authenticationConfig,
    props.authenticationConfig
  );
  const { displayCaptcha, hcaptchaSiteKey } = authenticationConfig;

  if (!displayCaptcha) return null;

  return (
    <div className="form-group-addon form-group-captcha margin-top-sm border-top padding-top-sm">
      <CaptchaField fieldName="captcha" required sitekey={hcaptchaSiteKey} />
    </div>
  );
};

const AuthenticationCaptcha_authenticationConfig = graphql__503e376bc0c71fc8ee74;

export default AuthenticationCaptcha;
